module.exports = __webpack_public_path__ + "static/media/location.bdfeb66a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/MemberProfile/location.svg
// module id = 364
// module chunks = 0